document.addEventListener("DOMContentLoaded", function () {
  const parents = document.querySelectorAll("li.level0.menu-parent");

  parents.forEach(item => {
    item.addEventListener("mouseenter", function () {
      item.classList.add("visible");
    });

    item.addEventListener("mouseleave", function () {
      item.classList.remove("visible");
    });
  });
});